import {getCurrencyDecimals} from '../currencies';

export const formatMoneyInDecimals = (value: number | null | undefined, currencyCode: string | null | undefined): number => {
  const decimals = getCurrencyDecimals(currencyCode);

  return ((value || 0) / Math.pow(10, decimals));
};

export default formatMoneyInDecimals;